import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

function Iletisim() {
  const [form, setForm] = useState({ isim: '', telefon: '', mesaj: '' });

  // Akıllı Etiket Tıklama Motoru
  const handleTagClick = (tag) => {
    setForm((prev) => ({
      ...prev,
      mesaj: prev.mesaj ? `${prev.mesaj} - ${tag}` : tag // Mevcut mesajın yanına ekler
    }));
  };

  const handleWhatsAppGonder = (e) => {
    e.preventDefault();
    const telefonNumarasi = "905454167141";
    const whatsappMetni = `Merhaba Demir Grup, ben ${form.isim}.\n\nİletişim Numaram: ${form.telefon}\n\nMesajım: ${form.mesaj}`;
    
    window.open(`https://wa.me/${telefonNumarasi}?text=${encodeURIComponent(whatsappMetni)}`, '_blank');
  };

  return (
    <div className="iletisim-page">
      
      <Helmet>
        <title>İletişim & Ücretsiz Keşif Talebi | Demir Grup Ankara</title>
        <meta name="description" content="Ankara güvenlik kamera sistemleri, zayıf akım ve inşaat filesi projeleriniz için mühendislerimizle iletişime geçin. Ücretsiz keşif avantajı." />
        <meta name="keywords" content="demir grup iletişim, ankara güvenlik firması telefon, kamera kurulumu ankara iletişim, ücretsiz keşif" />
        <link rel="canonical" href="https://www.ddemirgrup.com.tr/iletisim" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Demir Grup Müşteri Hizmetleri ve İletişim",
            "description": "Güvenlik sistemleri keşif ve projelendirme iletişim sayfası.",
            "url": "https://www.ddemirgrup.com.tr/iletisim",
            "mainEntity": {
              "@type": "ContactPoint",
              "telephone": "+90-545-416-7141",
              "contactType": "customer service",
              "areaServed": "TR",
              "availableLanguage": "Turkish"
            }
          })}
        </script>
      </Helmet>

      <div className="iletisim-header">
        <h1>Projenizi Konuşalım</h1>
        <p>Güvenlik ve altyapı ihtiyaçlarınız için uzman mühendislerimizle hemen iletişime geçin.</p>
      </div>

      <div className="iletisim-container">
        
        {/* SOL TARAF: Eşit Boyutlu Kartlar */}
        <div className="iletisim-cards">
          {/* SİHİRLİ KOD 1: GERÇEK GOOGLE MAPS YÖNLENDİRME LİNKİ EKLENDİ */}
          <a href="https://www.google.com/maps/search/?api=1&query=Malazgirt+Mah.+Buhara+Cad.+Sincan+Ankara" target="_blank" rel="noopener noreferrer" className="vip-contact-card clickable-card">
            <div className="card-icon">📍</div>
            <div className="card-info">
              <h3>Merkez Ofis</h3>
              <p>Malazgirt Mah. Buhara Cad.</p>
              <p>71/C Sincan / ANKARA</p>
            </div>
          </a>

          <a href="tel:+905454167141" className="vip-contact-card clickable-card">
            <div className="card-icon">📞</div>
            <div className="card-info">
              <h3>Hızlı İletişim</h3>
              <p>0545 416 71 41</p>
              <p>0530 509 06 31</p>
            </div>
          </a>

          <a href="mailto:ddemirgrup@gmail.com" className="vip-contact-card clickable-card">
            <div className="card-icon">✉️</div>
            <div className="card-info">
              <h3>E-Posta Adresi</h3>
              <p>ddemirgrup@gmail.com</p>
            </div>
          </a>
        </div>

        {/* SAĞ TARAF: VIP Proje Formu ve Lüks Özellikler */}
        <div className="iletisim-form-wrapper">
          
          <div className="live-status">
            <div className="pulse-dot"></div> Müşteri Hizmetleri Aktif
          </div>

          <div className="form-title-area">
            <h2>VIP Teklif İste</h2>
            <p>Hızlı teklif için projenizle ilgili detayları seçin veya yazın.</p>
          </div>
          
          <form onSubmit={handleWhatsAppGonder} className="vip-form">
            <input 
              type="text" 
              placeholder="Adınız Soyadınız" 
              required 
              value={form.isim}
              onChange={(e) => setForm({...form, isim: e.target.value})} 
            />
            <input 
              type="tel" 
              placeholder="Telefon Numaranız" 
              required 
              value={form.telefon}
              onChange={(e) => setForm({...form, telefon: e.target.value})} 
            />
            <textarea 
              placeholder="Proje Detayları veya Mesajınız..." 
              required 
              value={form.mesaj} 
              onChange={(e) => setForm({...form, mesaj: e.target.value})} 
            ></textarea>
            
            <button type="submit" className="wa-submit-btn">
              <span className="wa-icon">💬</span> WhatsApp'tan Teklif Al 🚀
            </button>
          </form>
        </div>

      </div>

      <div className="map-container">
        <iframe 
          title="Demir Grup Konum"
          src="https://maps.google.com/maps?q=Malazgirt%20Mah.%20Buhara%20Cad.%2071/C%20Sincan%20Ankara&t=&z=15&ie=UTF8&iwloc=&output=embed"
          width="100%" 
          height="450" 
          style={{border:0}} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          className="dark-map"
        ></iframe>
      </div>

    </div>
  );
}

export default Iletisim;